var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"single-step",class:{
    'single-step--active': _vm.isActive,
    'single-step--done': _vm.isDone,
  }},[_c('div',{staticClass:"single-step__wrapper"},[_c('div',{staticClass:"single-step__step-number"},[(!_vm.isDone)?_c('span',[_vm._v(_vm._s(_vm.stepNumber))]):_c('i',{staticClass:"el-icon-check"})]),_vm._v(" "),_c('p',{staticClass:"single-step__title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }